import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BehaviorSubject } from "rxjs";
import {
  CfsTemplateBaseComponent,
  CfsTemplateError,
  CfsTemplateErrorData,
  CfsTemplateMediaConfig,
  defaultCfsTemplateMediaConfig,
  TemplateAnimationType,
  TemplateProperties,
  UrlContentSettings
} from "clearline-common";
import { CfsTemplateErrorDataFields, CfsTemplateErrorTypes, generateCommonCfsTemplateError } from "../cfs-template-errors";

@Component({
  selector: "lib-image-template",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./image-template.component.html",
  styleUrls: ["./image-template.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageTemplateComponent implements CfsTemplateBaseComponent, OnInit {
  @Input() mediaConfig: CfsTemplateMediaConfig = defaultCfsTemplateMediaConfig;
  @Input() isPrintView = false;
  @Input() animationType = TemplateAnimationType.Animated;

  @Input() set templateProperties(templateProperties: TemplateProperties | null) {
    const { ImageUrl } = (templateProperties as UrlContentSettings) || {};
    this.url = ImageUrl ?? "";
  }

  @Output() ready = new EventEmitter<void>();
  @Output() error = new EventEmitter<CfsTemplateError>();

  protected url = "";
  protected animated$ = new BehaviorSubject<boolean>(false);

  ngOnInit(): void {
    if (this.animationType === TemplateAnimationType.Animated) {
      this.animated$.next(true);
    }
  }

  play(): void {
    this.playAnimation();
  }

  stop(): void {
    this.stopAnimation();
  }

  pause(): void {
    this.stopAnimation();
  }

  restart(): void {
    this.playAnimation();
  }

  protected onLoad(): void {
    this.ready.emit();
  }

  protected onError(): void {
    const errorData: CfsTemplateErrorData = { field: CfsTemplateErrorDataFields.Url, value: this.url };
    const templateError: CfsTemplateError = generateCommonCfsTemplateError(CfsTemplateErrorTypes.ImageLoad, "", errorData);

    this.error.emit(templateError);
  }

  private playAnimation(): void {
    this.animated$.next(
      this.animationType === TemplateAnimationType.Animated || this.animationType === TemplateAnimationType.OnDemandAnimated
    );
  }

  private stopAnimation(): void {
    this.animated$.next(false);
  }
}
